
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Innovacrystacabpune() {



    const cardData =
    {
        keyword: ' Innova Crysta Cab Pune',
        heading: 'Prince Cabs: Innova Crysta Cab Pune',
        headingDescription: 'Prince Cabs offers premium Innova Crysta Cab Pune services, ideal for family travel, corporate trips, airport transfers, and outstation journeys. Our spacious and well-maintained Innova Crysta vehicles come equipped with modern amenities to ensure maximum comfort, safety, and luxury. With professional chauffeurs, flexible schedules, and transparent pricing, we make your travel experience smooth and hassle-free. Choose Prince Cabs’ trusted Innova Crysta cab service in Pune for reliability, convenience, and affordable fares.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was once the seat of the powerful Peshwas of the Maratha Empire. Though much of it was destroyed by fire in 1828, its grand gates, massive walls, and sprawling gardens still stand tall. The evening light-and-sound show brings alive tales of Maratha bravery. Visitors enjoy exploring its ruins and imagining its glorious past. It is a must-visit landmark for history lovers in Pune. Shaniwar Wada is the perfect blend of legend and architecture."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, built in 1892, is an architectural marvel with deep historical importance. During the Quit India Movement, Mahatma Gandhi, Kasturba Gandhi, and Sarojini Naidu were imprisoned here. The palace now houses a museum with artifacts, photos, and personal belongings of Gandhi. Its sprawling gardens provide a peaceful retreat for visitors. It is a national monument of pride and sacrifice. The palace stands as a timeless reminder of India’s freedom struggle."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, about 30 km from Pune, is a historic hill fortress famous for the 1670 Battle of Sinhagad. The fort’s ruins, bastions, and watchtowers tell stories of Maratha valor. Trekkers enjoy scenic routes, especially during monsoon when the hills turn lush green. From the summit, panoramic views of the Sahyadris are breathtaking. Local vendors sell traditional pithla-bhakri, adding to the fort experience. It is a favorite among history enthusiasts and nature lovers."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous religious landmark, dedicated to Lord Ganesha. The idol is adorned with gold and jewels, attracting thousands of devotees daily. During Ganesh Chaturthi, the temple is decorated with grandeur and cultural programs. It is also involved in various charitable activities. The temple’s central location makes it easily accessible. It is both a spiritual and cultural icon of Pune."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill, one of Pune’s highest points, offers panoramic views of the entire city. At its summit lies the Parvati Temple complex, dedicated to Lord Shiva and Goddess Parvati. The climb of more than 100 steps is rewarding with peace and spirituality at the top. The Peshwa Museum nearby adds historical depth. Sunrises and sunsets from the hill are especially captivating. It is a serene escape from the city’s hustle."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. It features massive pillars, a stone-carved Nandi, and an unfinished mandapa. Despite being in the city center, it offers a peaceful environment. The temple is a fine example of Rashtrakuta-era architecture. Visitors often come here for meditation and photography. It remains a hidden gem in Pune’s heritage map."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove of over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include musical instruments, sculptures, everyday objects, and the recreated Mastani Mahal. The museum reflects the cultural richness of Maharashtra and India. It fascinates both art lovers and historians alike. Its three-storey building itself is a heritage attraction. It is one of Pune’s most unique museums."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "Osho International Meditation Resort in Koregaon Park is a world-renowned spiritual retreat. Visitors from across the globe come here for meditation, wellness therapies, and yoga. Surrounded by serene gardens and modern architecture, it offers a peaceful escape. The ashram promotes holistic well-being and personal growth. Its vibrant international community adds cosmopolitan charm. It is a unique blend of spirituality and modern lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity, located in Viman Nagar, is Pune’s largest lifestyle and shopping mall. It houses hundreds of international and Indian brands, offering a world-class retail experience. Entertainment includes multiplex cinemas, gaming zones, and live events. The mall also features a wide range of restaurants and cafés. Seasonal festivals like Diwali and Christmas add vibrancy. It is the ultimate hub for shopping, dining, and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located about 20 km from Pune, is a scenic spot surrounded by hills. The reservoir supplies water to the city and offers natural beauty. Families enjoy picnics, boating, and street food near the dam. Monsoon enhances its charm with mist and greenery. Evenings here are especially peaceful with cool breezes. It is a refreshing escape for city dwellers."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by Mulshi Dam, is a serene outstation spot near Pune. It is surrounded by Sahyadri hills, forests, and waterfalls. Visitors enjoy camping, nature walks, and photography here. During monsoon, the lake looks spectacular with overflowing water and lush valleys. Eco-resorts nearby offer a comfortable stay amidst nature. It is ideal for couples, families, and adventure seekers."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Located on Senapati Bapat Road, Chaturshringi Temple is one of Pune’s oldest and most revered shrines. Dedicated to Goddess Chaturshringi (Durga), it requires devotees to climb over 100 steps to reach the sanctum. The temple is especially grand during Navratri with vibrant celebrations. It attracts devotees from all over Maharashtra. The views from the hilltop add to its charm. It is both a spiritual and cultural landmark."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "This war memorial is dedicated to Indian soldiers who sacrificed their lives post-independence. It displays tanks, weapons, and war memorabilia. The museum inside narrates stories of India’s military history. Visitors attend the evening flag retreat ceremony, which is deeply moving. It is both educational and inspiring for families and students. The memorial instills pride and patriotism."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden, spread across 39 acres, is a lush botanical park in Pune. Managed by the Agri-Horticultural Society, it houses exotic trees, flower nurseries, and shaded walking paths. Families come here for picnics and relaxation. The annual flower show is a highlight for nature lovers. It is one of Pune’s oldest gardens with colonial-era history. A green oasis in the bustling city, it offers peace and tranquility."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, Pune’s highest hill, is a popular trekking and jogging destination. The hilltop offers panoramic views of the entire city. It is rich in biodiversity, with birds, trees, and fresh air. Fitness enthusiasts flock here for morning walks and cycling. Sunrises and sunsets from Vetal Hill are breathtaking. It is Pune’s natural lung and a much-needed retreat for nature lovers."
  }
],


"services": [
    {
        "name": "Innova Crysta Cab",
        "description": "Premium Innova Crysta cab service offering luxurious and comfortable rides for city and outstation travel. Experience spacious interiors, advanced safety features, and courteous drivers ensuring a smooth journey for business trips, family outings, and special occasions."
    },
    {
        "name": "Innova Car Rent per Day",
        "description": "Affordable Innova car rental available on a daily basis with flexible plans to suit your travel needs. Whether for short city trips or long outstation journeys, enjoy clean, well-maintained vehicles and professional drivers at competitive daily rates."
    },
    {
        "name": "Innova Crysta Taxi Rate",
        "description": "Transparent and competitive taxi rates for Innova Crysta cabs, providing excellent value for comfortable and reliable transportation. Our pricing is designed to be affordable without compromising on quality, with no hidden charges."
    },
    {
        "name": "Innova Crysta per km Rate for Outstation",
        "description": "Cost-effective per kilometer pricing for Innova Crysta taxis on outstation trips, perfect for weekend getaways, business travel, or family vacations. Enjoy fixed rates with no surprises and expert drivers who know the best routes for timely arrivals."
    },
    {
        "name": "Innova 8 Seater on Rent",
        "description": "Spacious 8-seater Innova available for rent, ideal for group travel, corporate outings, or family trips. Benefit from ample legroom, luggage space, and comfortable seating for longer journeys, along with professional driver services."
    },
    {
        "name": "Innova Crysta Cab Booking",
        "description": "Easy and quick Innova Crysta cab booking service with instant confirmation. Choose your preferred travel dates and timings for a seamless experience, supported by friendly customer service and well-maintained vehicles."
    },
    {
        "name": "Innova Crysta Hire Charges",
        "description": "Detailed and transparent hire charges for Innova Crysta taxis including per day, per km, and package rates. We offer affordable options suitable for short trips, long-distance travel, and special occasions with no hidden fees."
    },
    {
        "name": "Innova Crysta Outstation Charges",
        "description": "Affordable outstation charges for Innova Crysta cab rentals with flexible packages catering to one-way and round trips. Enjoy comfortable rides with experienced drivers ensuring safety and timely service for your out-of-town journeys."
    },
    {
        "name": "Innova Crysta on Rent Pune",
        "description": "Book an Innova Crysta on rent in Pune for hassle-free local or outstation travel. Our fleet includes well-maintained vehicles with professional drivers, perfect for sightseeing tours, business trips, airport transfers, and family outings."
    },
    {
        "name": "Innova Crysta Taxi Booking",
        "description": "Convenient Innova Crysta taxi booking platform with 24/7 availability. Get instant booking confirmation, affordable pricing, and customer support to ensure your travel plans are smoothly executed with reliable and comfortable transport."
    },
    {
        "name": "Toyota Innova Crysta Taxi",
        "description": "Travel in the reliable and luxurious Toyota Innova Crysta taxi, equipped with modern amenities, comfortable seating, and safety features. Perfect for both city rides and long-distance travel, offering premium comfort and excellent service."
    },
    {
        "name": "Innova Crysta Pune to Mumbai Service",
        "description": "Specialized Innova Crysta taxi service for the Pune to Mumbai route, combining convenience, luxury, and punctuality. Ideal for business travelers, families, and tourists looking for a premium and hassle-free intercity travel experience."
    },
    {
        "name": "Innova Crysta Family Cab",
        "description": "Family-friendly Innova Crysta cab service with spacious interiors, child safety features, and ample luggage space. Perfect for comfortable family trips, weekend getaways, and group travel with professional and courteous drivers."
    },
    {
        "name": "Luxury Innova Crysta Pune",
        "description": "Experience luxury with our Innova Crysta cab service in Pune, offering top-notch vehicles, premium interiors, and exceptional customer care. Suitable for corporate travel, weddings, and special events requiring a sophisticated touch."
    }
],
"tableData": [
    ["Innova Crysta Cab", "Innova Car Rent per Day"],
    ["Innova Crysta Taxi Rate", "Innova Crysta per km Rate for Outstation"],
    ["Innova 8 Seater on Rent", "Innova Crysta Cab Booking"],
    ["Innova Crysta Hire Charges", "Innova Crysta Outstation Charges"],
    ["Innova Crysta on Rent Pune", "Innova Crysta Taxi Booking"],
    ["Toyota Innova Crysta Taxi", "Innova Crysta Pune to Mumbai Service"],
    ["Innova Crysta Family Cab", "Luxury Innova Crysta Pune"]
],


"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Crysta Cab Service in Pune",
        "WhyChoosedescription": "Prince Cabs offers top-notch Innova Crysta cab services in Pune, perfect for airport transfers, city tours, corporate travel, and family outings. Experience spacious seating, plush interiors, and smooth rides designed to make your travel comfortable and enjoyable within Pune and nearby areas."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Our Innova Crysta fleet in Pune is regularly serviced and sanitized before every trip, ensuring hygiene and safety. Equipped with air conditioning, GPS, and modern amenities, our vehicles promise a clean and secure journey every time you ride with us."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Knowledge",
        "WhyChoosedescription": "All our drivers are professionally trained, familiar with Pune’s traffic and routes, and committed to safe and courteous service. Whether it’s a quick city trip or an extended drive to nearby destinations, you can trust our drivers for timely and comfortable travel."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Suit Your Schedule",
        "WhyChoosedescription": "Book your Innova Crysta cab in Pune easily via phone, WhatsApp, or online platform. Choose from hourly rentals, full-day packages, or outstation trips with transparent pricing and instant confirmation tailored to your travel needs."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Payment Methods",
        "WhyChoosedescription": "We offer clear, competitive pricing for Innova Crysta cabs in Pune with no hidden charges. Pay conveniently through UPI, credit/debit cards, net banking, or cash, ensuring a hassle-free booking and payment experience."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Smooth Ride",
        "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist with your Innova Crysta bookings, provide real-time updates, and ensure your journey in Pune is seamless and worry-free."
    }
]




























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Innova Crysta cabs in Pune?',
        answer: 'Yes, Prince Cabs offers premium Innova Crysta cabs in Pune for local travel, airport transfers, and outstation journeys. Ideal for families, executives, and group travel.',
    },
    {
        question: 'What features does the Innova Crysta offer?',
        answer: 'Innova Crysta cabs come with plush captain seats, rear AC vents, spacious interiors, powerful engine, and ample luggage space for a comfortable ride.',
    },
    {
        question: 'What is the fare for Innova Crysta cab in Pune?',
        answer: 'The fare for Innova Crysta in Pune starts at ₹20/km for outstation and from ₹500 for local hourly rentals. Final charges depend on trip type and duration.',
    },
    {
        question: 'Is Innova Crysta available for airport drop and pickup in Pune?',
        answer: 'Yes, Prince Cabs offers punctual and reliable airport transfers in Innova Crysta from anywhere in Pune to Pune Airport and vice versa.',
    },
    {
        question: 'Can I book an Innova Crysta for a full day in Pune?',
        answer: 'Absolutely! We offer flexible hourly rental packages for Innova Crysta in Pune, perfect for local sightseeing, events, and business meetings.',
    },
    {
        question: 'Are the Innova Crysta cabs sanitized and well-maintained?',
        answer: 'Yes, all our Innova Crysta vehicles are thoroughly sanitized and serviced before every trip. Our drivers are professional and background verified.',
    },
    {
        question: 'How can I book an Innova Crysta cab in Pune with Prince Cabs?',
        answer: 'You can book easily via our website or by calling our support team. Just share your travel details and we’ll assign a clean, comfortable Crysta with a professional driver.',
    },
];

const testimonials = [
    {
        name: "Mr. Pravin Joshi",
        position: "Senior Executive",
        text: "Booked an Innova Crysta from Prince Cabs for a business trip in Pune. Extremely comfortable ride and very professional driver. Will book again soon.",
        image: "/img/testimonial/testimonial-thumb-crysta-pune-1.png",
    },
    {
        name: "Mrs. Meenal Agarwal",
        position: "Event Organizer",
        text: "Used Innova Crysta for guest transport during a family event in Pune. The cab was clean, arrived on time, and service was excellent. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-crysta-pune-2.png",
    },
];



































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta Cab Pune",
  "image": "https://princecab.com/assets/images/innova-crysta-cab-pune.jpg",
  "description": "Book Innova Crysta cab in Pune with Prince Cabs for affordable daily rentals, outstation trips, and family rides. Enjoy luxury, spaciousness, and reliable service.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/innova-crysta-cab-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Innova Crysta Cab Pune | Luxury Innova Rental & Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Book Innova Crysta cab in Pune with Prince Cabs for affordable daily rentals, outstation trips, and family rides. Luxury, spacious, and reliable taxi service."
  />
  <meta
    name="keywords"
    content="Innova Crysta Cab, Innova Car Rent per Day, Innova Crysta Taxi Rate, Innova Crysta per km Rate for Outstation, Innova 8 Seater on Rent, Innova Crysta Cab Booking, Innova Crysta Hire Charges, Innova Crysta Outstation Charges, Innova Crysta on Rent Pune, Innova Crysta Taxi Booking, Toyota Innova Crysta Taxi, Innova Crysta Pune to Mumbai Service, Innova Crysta Family Cab, Luxury Innova Crysta Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/32.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovacrystacabpune;